module.exports = __webpack_public_path__ + "img/distanceWedge2.6c8ad13d.png";